"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrizeList = usePrizeList;
const vue_demi_1 = require("vue-demi");
const api_1 = require("../../../../common-redpacket/static/src/render/api");
const type_1 = require("../../../../common-redpacket/static/src/render/type");
function usePrizeList(actSign) {
    const state = (0, vue_demi_1.reactive)({
        prizeList: []
    });
    const { state: redpackState } = (0, api_1.useRedpackData)(actSign);
    function updateState(newVal) {
        if (!newVal) {
            return;
        }
        const { record, matchRule } = newVal;
        if (!record || !matchRule) {
            return;
        }
        if (matchRule.type !== type_1.CommonRedpacketActivityRuleType.API_SEND) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const extra = matchRule.extra;
        if (!extra) {
            return;
        }
        const prizeUuid = record.extra.prizeUuid;
        if (!prizeUuid) {
            return;
        }
        const { rules = [] } = extra;
        const rule = rules.find((item) => item.uuid === prizeUuid);
        if (!rule) {
            return;
        }
        const { text = [] } = rule;
        state.prizeList = text;
        return;
    }
    (0, vue_demi_1.watch)(() => redpackState.data, (newVal) => {
        updateState(newVal);
    });
    updateState(redpackState.data);
    return {
        state
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBSUEsb0NBZ0RDO0FBcERELHVDQUEyQztBQUMzQyw0RUFBb0Y7QUFDcEYsOEVBQXNHO0FBRXRHLFNBQWdCLFlBQVksQ0FBQyxPQUFlO0lBQ3hDLE1BQU0sS0FBSyxHQUFHLElBQUEsbUJBQVEsRUFBQztRQUNuQixTQUFTLEVBQUUsRUFBcUQ7S0FDbkUsQ0FBQyxDQUFDO0lBQ0gsTUFBTSxFQUFFLEtBQUssRUFBRSxZQUFZLEVBQUUsR0FBRyxJQUFBLG9CQUFjLEVBQUMsT0FBTyxDQUFDLENBQUM7SUFFeEQsU0FBUyxXQUFXLENBQUMsTUFBZ0M7UUFDakQsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQ1YsT0FBTztRQUNYLENBQUM7UUFDRCxNQUFNLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxHQUFHLE1BQU0sQ0FBQztRQUNyQyxJQUFJLENBQUMsTUFBTSxJQUFJLENBQUMsU0FBUyxFQUFFLENBQUM7WUFDeEIsT0FBTztRQUNYLENBQUM7UUFDRCxJQUFJLFNBQVMsQ0FBQyxJQUFJLEtBQUssc0NBQStCLENBQUMsUUFBUSxFQUFFLENBQUM7WUFDOUQsT0FBTztRQUNYLENBQUM7UUFDRCw4REFBOEQ7UUFDOUQsTUFBTSxLQUFLLEdBQUcsU0FBUyxDQUFDLEtBQWlFLENBQUM7UUFDMUYsSUFBSSxDQUFDLEtBQUssRUFBRSxDQUFDO1lBQ1QsT0FBTztRQUNYLENBQUM7UUFDRCxNQUFNLFNBQVMsR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQztRQUN6QyxJQUFJLENBQUMsU0FBUyxFQUFFLENBQUM7WUFDYixPQUFPO1FBQ1gsQ0FBQztRQUNELE1BQU0sRUFBRSxLQUFLLEdBQUcsRUFBRSxFQUFFLEdBQUcsS0FBSyxDQUFDO1FBQzdCLE1BQU0sSUFBSSxHQUFHLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssU0FBUyxDQUFDLENBQUM7UUFDM0QsSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDO1lBQ1IsT0FBTztRQUNYLENBQUM7UUFFRCxNQUFNLEVBQUUsSUFBSSxHQUFHLEVBQUUsRUFBRSxHQUFHLElBQUksQ0FBQztRQUMzQixLQUFLLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQztRQUN2QixPQUFPO0lBQ1gsQ0FBQztJQUVELElBQUEsZ0JBQUssRUFDRCxHQUFHLEVBQUUsQ0FBQyxZQUFZLENBQUMsSUFBSSxFQUN2QixDQUFDLE1BQU0sRUFBRSxFQUFFO1FBQ1AsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3hCLENBQUMsQ0FDSixDQUFDO0lBRUYsV0FBVyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMvQixPQUFPO1FBQ0gsS0FBSztLQUNSLENBQUM7QUFDTixDQUFDIn0=